<template>
    <component v-if="content" :is="component" />
</template>

<script>
    export default {
        props: {
            content: String,
        },
        computed: {
            component() {
                return {
                    template: `<span>${this.content}</span>`,
                    components: {
                        'pastille-ekip': {
                            props: {
                                orange: Boolean,
                                bleu: Boolean,
                            },
                            template: '<span class="ekip-badge" :class="classes"></span>',
                            computed: {
                                classes() {
                                    return {
                                        'ekip-badge--orange': this.orange,
                                        'ekip-badge--blue': this.bleu,
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</script>
